"use strict";

class TimelineImageGallery {
    constructor() {
        const galleries = document.querySelectorAll(
            ".ce-timeline-image-gallery"
        );

        galleries.forEach((gallery) => {
            const previousButton = gallery.querySelector(
                ".timeline-item__button--previous"
            );
            const nextButton = gallery.querySelector(
                ".timeline-item__button--next"
            );

            previousButton.addEventListener("click", () =>
                goToSlide("previous")
            );
            nextButton.addEventListener("click", () => goToSlide("next"));

            function goToSlide(direction = "next") {
                const slides = gallery.querySelectorAll(
                    ".ce-timeline-image-gallery__image"
                );
                const currentSlide = [...slides].find((slide) =>
                    slide.classList.contains(
                        "ce-timeline-image-gallery__image--active"
                    )
                );

                const previousSlide =
                    [...slides].find(
                        (slide) =>
                            slide.dataset.slide ==
                            Number(currentSlide.dataset.slide) - 1
                    ) || slides[slides.length - 1];
                const nextSlide =
                    [...slides].find(
                        (slide) =>
                            slide.dataset.slide ==
                            Number(currentSlide.dataset.slide) + 1
                    ) || slides[0];

                const activeSlideCounter = gallery.querySelector(
                    "[data-active-slide-counter]"
                );
                const activeSlideTitle = gallery.querySelector(
                    "[data-active-slide-title]"
                );

                if (direction === "next") {
                    nextSlide.classList.remove(
                        "ce-timeline-image-gallery__image--previous"
                    );
                    nextSlide.classList.add(
                        "ce-timeline-image-gallery__image--next",
                        "ce-timeline-image-gallery__image--no-animation"
                    );

                    setTimeout(() => {
                        nextSlide.classList.remove(
                            "ce-timeline-image-gallery__image--next",
                            "ce-timeline-image-gallery__image--no-animation"
                        );
                        nextSlide.classList.add(
                            "ce-timeline-image-gallery__image--active"
                        );
                        currentSlide.classList.remove(
                            "ce-timeline-image-gallery__image--active"
                        );
                        currentSlide.classList.add(
                            "ce-timeline-image-gallery__image--previous"
                        );
                        activeSlideCounter.innerHTML = nextSlide.dataset.slide;
                        activeSlideTitle.innerHTML =
                            nextSlide.dataset.slideTitle;
                    }, 1);
                } else if (direction === "previous") {
                    previousSlide.classList.remove(
                        "ce-timeline-image-gallery__image--next"
                    );
                    previousSlide.classList.add(
                        "ce-timeline-image-gallery__image--previous",
                        "ce-timeline-image-gallery__image--no-animation"
                    );

                    setTimeout(() => {
                        previousSlide.classList.remove(
                            "ce-timeline-image-gallery__image--previous",
                            "ce-timeline-image-gallery__image--no-animation"
                        );
                        previousSlide.classList.add(
                            "ce-timeline-image-gallery__image--active"
                        );
                        currentSlide.classList.remove(
                            "ce-timeline-image-gallery__image--active"
                        );
                        currentSlide.classList.add(
                            "ce-timeline-image-gallery__image--next"
                        );
                        activeSlideCounter.innerHTML =
                            previousSlide.dataset.slide;
                        activeSlideTitle.innerHTML =
                            previousSlide.dataset.slideTitle;
                    }, 1);
                }
            }
        });
    }
}

module.exports = TimelineImageGallery;
